export default __webpack_public_path__ + "static/media/green_coolant.fa7272c3.webp";